import { toast } from "react-toastify";

import { AnyAction } from "redux";
import { call, put, takeLatest } from "redux-saga/effects";

import { MessageResponse } from "../../../_helpers/iResponse";
import { GET_REFERENTIALS } from "../../referential/constants";
import { getReferentials } from "../../referential/sagas";
import * as Constants from "../constants";
import { IResponseAuth } from "../reducers";
import * as Services from "../services";

function* logIn(action: AnyAction) {
  try {
    const payload: IResponseAuth = yield call(
      Services.loginUserService,
      action.email,
      action.password,
    );

    yield put({ type: Constants.TOGGLE_LOGIN_SUCCESS, payload });
    // yield call(getUser, { type: Constants.GET_USER, id: data?.data?.id });
    yield call(getReferentials, { type: GET_REFERENTIALS });
    // yield call(getTeamInit, { type: GET_TEAM });

    return action.resolve();
  } catch (error: any) {
    //@todo check errors messages
    if (error?.response?.data?.messages) {
      const messages = error.response.data.messages;
      messages.forEach((message: any) => {
        toast.error(message);
      });
    } else {
      toast.error(error.message);
    }
    yield put({ type: Constants.TOGGLE_LOGIN_FAILED, error });
  }
}

function* logOut(action: AnyAction) {
  try {
    const { data }: IResponseAuth = yield call(Services.logoutUserService);

    yield put({
      type:
        data.message === "OK"
          ? Constants.TOGGLE_LOGOUT_SUCCESS
          : Constants.TOGGLE_LOGOUT_FAILED,
      payload: data.data,
    });
    if (data.message === "OK") action.resolve();
    else action.reject();
  } catch (error) {
    yield put({ type: Constants.TOGGLE_LOGOUT_FAILED, error });
  }
}

function* getUser(_action: AnyAction) {
  try {
    const { data }: IResponseAuth = yield call(Services.GetUserService);
    if (data.message === "OK")
      yield put({
        type: Constants.GET_USER_SUCCESS,
        payload: { ...data.data },
      });
  } catch (error) {
    yield put({ type: "GET_USER_FAILED", error });
  }
}

function* verifyPhoneNumber(action: AnyAction) {
  try {
    const { data }: IResponseAuth = yield call(
      Services.verifyPhoneNumberService,
      parseInt(action.smsCode),
    );

    data.message !== "OK" ? action.reject() : action.resolve();
  } catch (e) {
    console.error(e);
    yield put({ type: Constants.VERIFY_PHONE_NUMBER_FAILED, e });
  }
}

function* register(action: AnyAction) {
  try {
    const { data }: IResponseAuth = yield call(Services.register, {
      email: action.email,
      password: action.password,
      phone: action.phone,
      firstname: action.firstname,
      name: action.name,
    });

    data.message !== "Created" ? action.reject() : action.resolve();

    yield put({
      type:
        data.message === "Created"
          ? Constants.TOGGLE_REGISTER_SUCCESS
          : Constants.TOGGLE_REGISTER_FAILED,
      payload: {
        ...data.data,
        email: action.email,
        phone: action.phone,
        firstname: action.firstname,
        name: action.name,
      },
    });
  } catch (e) {
    console.error(e);
    yield put({ type: Constants.TOGGLE_REGISTER_FAILED, e });
  }
}
//TODO Refacto
function* getCompanyInfos(action: AnyAction) {
  try {
    const result: any = yield call(Services.getCompanyInfos, action.company);
    if (result.message && result.message === "Society doesn't exist")
      return action.resolve([]);
    if (result.message && result.message !== "OK") return action.reject();
    return action.resolve(result.data);
  } catch (error) {
    yield put({ type: "GET_COMPANY_INFO_SIREN", error });
  }
}

function* emailExists(action: AnyAction) {
  try {
    const { data }: IResponseAuth = yield call(
      Services.emailExists,
      action.email,
    );
    data.message !== "OK"
      ? action.reject(data.data)
      : action.resolve(data.data);
  } catch (e) {
    yield put({ type: Constants.TOGGLE_EMAIL_EXISTS_FAILED, e });
  }
}

function* companyExists(action: AnyAction) {
  try {
    const { data }: IResponseAuth = yield call(
      Services.companyExists,
      action.siren,
    );
    data.message !== "OK"
      ? action.reject(data.data)
      : action.resolve(data.data);
  } catch (e) {
    yield put({ type: Constants.TOGGLE_COMPANY_EXISTS_FAILED, e });
  }
}

function* createCompany(action: AnyAction) {
  try {
    const { data }: IResponseAuth = yield call(
      Services.createCompany,
      action.infos,
    );
    if (data.message !== "Created")
      yield put({
        type: Constants.TOGGLE_CREATE_COMPANY_SUCCESS,
        payload: data?.data?.id,
      });
    data.message !== "Created"
      ? action.reject(data.data)
      : action.resolve(data.data?.id);
  } catch (e) {
    yield put({ type: Constants.TOGGLE_CREATE_COMPANY_FAILED, e });
  }
}

function* setIsLogged(action: AnyAction) {
  yield put({
    type:
      action.value === true
        ? Constants.SET_IS_LOGGED_TRUE
        : Constants.SET_IS_LOGGED_FALSE,
  });
}

function* tokenIsValid(action: AnyAction) {
  try {
    const { data }: IResponseAuth = yield call(Services.tokenIsValidService);
    if (!data) {
      yield put({ type: Constants.TOKEN_IS_VALID_FAILED });
      action.reject();
    } else if (data && data.message !== "OK") {
      yield put({ type: Constants.TOKEN_IS_VALID_FAILED });
      action.reject();
    } else action.resolve();
  } catch (e) {
    console.log(e);
  }
}

function* forgotPassword(action: AnyAction) {
  try {
    const { data, error }: IResponseAuth = yield call(
      Services.forgotPassword,
      action.email,
    );

    if (data.message === MessageResponse.OK) {
      yield put({
        type: Constants.FORGOT_PASSWORD_SUCCESS,
        payload: data.data,
      });
      return action.resolve(true);
    } else {
      return action.reject(error);
    }
  } catch (e) {
    yield put({ type: Constants.FORGOT_PASSWORD_FAILED, e });
    return action.reject(e);
  }
}

function* resetPassword(action: AnyAction) {
  try {
    const { data, error }: IResponseAuth = yield call(
      Services.resetPassword,
      action.password,
      action.token,
    );

    if (data.message === MessageResponse.OK) {
      yield put({
        type: Constants.RESET_PASSWORD_SUCCESS,
        payload: data.data,
      });
      return action.resolve(true);
    } else {
      return action.reject(error);
    }
  } catch (e) {
    yield put({ type: Constants.RESET_PASSWORD_FAILED, e });
    return action.reject(e);
  }
}

export const authSagas = [
  takeLatest(Constants.TOGGLE_LOGIN, logIn),
  takeLatest(Constants.TOGGLE_REGISTER, register),
  takeLatest(Constants.VERIFY_PHONE_NUMBER, verifyPhoneNumber),
  takeLatest(Constants.TOGGLE_LOGOUT, logOut),
  takeLatest(Constants.GET_COMPANY_INFOS, getCompanyInfos),
  takeLatest(Constants.GET_USER, getUser),
  takeLatest(Constants.TOGGLE_EMAIL_EXISTS, emailExists),
  takeLatest(Constants.TOGGLE_COMPANY_EXISTS, companyExists),
  takeLatest(Constants.TOGGLE_CREATE_COMPANY, createCompany),
  takeLatest(Constants.SET_IS_LOGGED, setIsLogged),
  takeLatest(Constants.TOKEN_IS_VALID, tokenIsValid),
  takeLatest(Constants.FORGOT_PASSWORD, forgotPassword),
  takeLatest(Constants.RESET_PASSWORD, resetPassword),
];
